const BORDEREAU_ACTION_SELECTOR = '.js-build-bordereau'

function createNode(tag, className, text) {
  const node = document.createElement(tag)
  if (className) node.className = className
  if (text !== undefined && text !== null) node.textContent = text
  return $(node)
}

function csrfToken() {
  return $('meta[name="csrf-token"]').attr('content')
}

function labelsFrom(element) {
  try {
    return JSON.parse($(element).attr('data-bordereau-labels'))
  } catch (_error) {
    return {}
  }
}

class BordereauModal {
  constructor(element) {
    this.element = element
    this.labels = labelsFrom(element)
    this.assessmentUrl = $(element).attr('data-assessment-url')
    this.buildUrl = $(element).attr('data-build-url')
    this.assessment = null
    this.fullNameSource = null
  }

  label(key) {
    return this.labels[key] || key
  }

  open() {
    const trigger = $(this.element)
    if (trigger.data('bordereau-modal-open')) return

    trigger.data('bordereau-modal-open', true)
    this.dialog = createNode('div', 'bordereau-modal')
    this.dialog.attr('title', this.label('title'))
    $('body').append(this.dialog)
    this.dialog.dialog({
      modal: true,
      width: Math.min(760, window.innerWidth - 30),
      dialogClass: 'active_admin_dialog bordereau-dialog',
      close: () => {
        trigger.removeData('bordereau-modal-open')
        this.dialog.remove()
      },
    })
    this.loadAssessment()
  }

  loadAssessment() {
    this.renderLoading(this.label('checking'))
    $.ajax({
      url: this.assessmentUrl,
      method: 'GET',
      dataType: 'json',
      cache: false,
    })
      .done((assessment) => this.renderAssessment(assessment, true))
      .fail((xhr) => this.renderRequestError(xhr))
  }

  renderLoading(message) {
    this.dialog.empty().append(createNode('div', 'bordereau-modal__loading', message))
    this.setButtons([])
  }

  renderAssessment(assessment, autoCreate) {
    this.assessment = assessment
    this.fullNameSource = assessment.full_name_choices.length === 1 ? 'insured' : null
    this.dialog.empty()

    const heading = this.label(`decision_${assessment.decision}`)
    this.dialog.append(createNode('div', `bordereau-modal__decision is-${assessment.decision}`, heading))
    this.renderIssues(assessment.issues)
    this.renderFullNameChoices(assessment.full_name_choices)
    this.renderPreview(assessment.preview)
    this.renderLocations(assessment)
    this.dialog.append(createNode('p', 'bordereau-modal__side-effects', this.label('side_effects_unchanged')))

    if (assessment.decision === 'clear' && autoCreate) {
      this.submitBuild()
    } else {
      this.renderAssessmentButtons()
    }
  }

  renderIssues(issues) {
    if (!issues.length) return

    const list = createNode('ul', 'bordereau-modal__issues')
    issues.forEach((issue) => {
      list.append(createNode('li', `is-${issue.level}`, issue.message))
    })
    this.dialog.append(list)
  }

  renderFullNameChoices(choices) {
    if (choices.length < 2) return

    const section = createNode('fieldset', 'bordereau-modal__full-name-choice')
    section.append(createNode('legend', null, this.label('full_name_choice')))
    choices.forEach((choice) => {
      const id = `bordereau-full-name-${choice.value}`
      const wrapper = createNode('label', 'bordereau-modal__radio')
      const input = createNode('input')
      input.attr({ type: 'radio', name: 'bordereau-full-name-source', id: id, value: choice.value })
      input.on('change', () => {
        this.fullNameSource = choice.value
        this.dialog.find('[data-preview-code="full_name"]').text(choice.full_name)
        this.updateConfirmButton()
      })
      wrapper.append(input)
      wrapper.append(createNode('span', null, `${choice.label}: ${choice.full_name}`))
      section.append(wrapper)
    })
    this.dialog.append(section)
  }

  renderPreview(preview) {
    this.dialog.append(createNode('h4', null, this.label('preview_title')))
    const table = createNode('table', 'bordereau-modal__preview')
    const body = createNode('tbody')
    preview.forEach((field) => {
      const row = createNode('tr')
      row.append(createNode('th', null, field.label))
      const value = field.code === 'full_name' && this.fullNameSource === null
        ? this.label('not_selected')
        : (field.value || this.label('empty_value'))
      const cell = createNode('td', null, value)
      cell.attr('data-preview-code', field.code)
      row.append(cell)
      body.append(row)
    })
    table.append(body)
    this.dialog.append(table)
  }

  renderLocations(assessment) {
    if (!assessment.bordereau.present && !assessment.reports.length) return

    this.dialog.append(createNode('h4', null, this.label('locations_title')))
    const list = createNode('ul', 'bordereau-modal__locations')
    if (assessment.bordereau.present) {
      const file = assessment.bordereau
      const item = createNode('li')
      if (file.download_url) {
        const link = createNode('a', null, file.filename || this.label('current_file'))
        link.attr('href', file.download_url)
        item.append(link)
      } else {
        item.append(createNode('span', null, file.filename || this.label('current_file')))
      }
      if (!file.storage_available) item.append(createNode('span', 'is-warning', ` — ${this.label('storage_missing')}`))
      list.append(item)
    }
    assessment.reports.forEach((report) => {
      const item = createNode('li')
      const text = `${this.label('report')} №${report.id}: ${this.label(`report_${report.state}`)}`
      if (report.url) {
        const link = createNode('a', null, text)
        link.attr('href', report.url)
        item.append(link)
      } else {
        item.append(createNode('span', null, text))
      }
      if (report.potentially_stale) {
        item.append(createNode('span', 'is-warning', ` — ${this.label('report_potentially_stale')}`))
      }
      list.append(item)
    })
    this.dialog.append(list)
  }

  renderAssessmentButtons() {
    if (this.assessment.decision === 'blocked') {
      this.setButtons([
        { text: this.label('recheck'), click: () => this.loadAssessment() },
        { text: this.label('close'), click: () => this.close() },
      ])
      return
    }

    const action = this.assessment.action === 'replace' ? 'replace' : 'create'
    const suffix = this.assessment.decision === 'warning' ? '_anyway' : ''
    this.setButtons([
      {
        text: this.label(`${action}${suffix}`),
        class: 'bordereau-confirm-button',
        click: () => this.submitBuild(),
      },
      { text: this.label('cancel'), click: () => this.close() },
    ])
    this.updateConfirmButton()
  }

  updateConfirmButton() {
    const required = this.assessment && this.assessment.full_name_choices.length > 1
    this.dialog
      .dialog('widget')
      .find('.bordereau-confirm-button')
      .prop('disabled', required && this.fullNameSource === null)
  }

  submitBuild() {
    const assessment = this.assessment
    const warningCodes = assessment.issues
      .filter((issue) => issue.level === 'warning')
      .map((issue) => issue.code)

    this.renderLoading(this.label('creating'))
    $.ajax({
      url: this.buildUrl,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      headers: { 'X-CSRF-Token': csrfToken() },
      data: JSON.stringify({
        fingerprint: assessment.fingerprint,
        acknowledged_warning_codes: warningCodes,
        full_name_source: this.fullNameSource,
      }),
    })
      .done((response) => this.renderSuccess(response))
      .fail((xhr) => this.handleBuildFailure(xhr))
  }

  renderSuccess(response) {
    this.dialog.empty()
    const message = response.result === 'replaced'
      ? this.label('success_replaced')
      : this.label('success_created')
    this.dialog.append(createNode('div', 'bordereau-modal__success', message))

    if (response.assessment) {
      this.updatePanel(response.assessment)
      const file = response.assessment.bordereau
      this.dialog.append(createNode('p', null, file.filename))
      const buttons = []
      if (file.download_url) {
        buttons.push({ text: this.label('download'), click: () => window.location.assign(file.download_url) })
      }
      buttons.push({ text: this.label('close'), click: () => this.close() })
      this.setButtons(buttons)
    } else {
      this.setButtons([{ text: this.label('close'), click: () => this.close() }])
    }
  }

  handleBuildFailure(xhr) {
    const response = xhr.responseJSON || {}
    if ((xhr.status === 409 || xhr.status === 422) && response.assessment) {
      this.renderAssessment(response.assessment, false)
      const key = xhr.status === 409 ? 'assessment_changed' : `error_${response.result}`
      this.dialog.prepend(createNode('div', 'bordereau-modal__error', this.label(key)))
      return
    }
    this.renderRequestError(xhr)
  }

  renderRequestError(xhr) {
    const response = xhr.responseJSON || {}
    this.dialog.empty()
    this.dialog.append(createNode('div', 'bordereau-modal__error', response.error || this.label('error_generic')))
    if (response.error_id) {
      this.dialog.append(createNode('p', null, `${this.label('error_id')}: ${response.error_id}`))
    }
    this.setButtons([
      { text: this.label('retry'), click: () => this.loadAssessment() },
      { text: this.label('close'), click: () => this.close() },
    ])
  }

  updatePanel(assessment) {
    const panel = $('#ticket-bordereau-panel')
    if (!panel.length) return

    panel.empty()
    const file = assessment.bordereau
    if (!file.present) {
      panel.append(createNode('div', 'bordereau-panel__empty', this.label('not_created')))
      return
    }

    const fileSection = createNode('div', 'bordereau-panel__file')
    const fileValue = file.download_url
      ? createNode('a', 'bordereau-panel__download', file.filename).attr('href', file.download_url)
      : createNode('span', null, file.filename)
    fileSection.append(this.panelRow(this.label('panel_file'), fileValue))
    fileSection.append(this.panelRow(this.label('panel_storage'), this.label(file.storage_available ? 'storage_available' : 'storage_missing')))
    if (file.size) fileSection.append(this.panelRow(this.label('panel_size'), this.formatSize(file.size)))
    if (file.generated_at) fileSection.append(this.panelRow(this.label('panel_generated_at'), this.formatTime(file.generated_at)))
    if (file.generated_by) fileSection.append(this.panelRow(this.label('panel_generated_by'), file.generated_by))
    fileSection.append(this.panelRow(this.label('panel_full_name_source'), this.label(`full_name_source_${file.full_name_source || 'legacy'}`)))
    fileSection.append(this.panelRow(this.label('panel_freshness'), this.label(`freshness_${file.freshness}`)))
    panel.append(fileSection)

    if (assessment.reports.length) {
      panel.append(createNode('h4', null, this.label('reports_title')))
      const list = createNode('ul', 'bordereau-panel__reports')
      assessment.reports.forEach((report) => {
        const item = createNode('li')
        const text = `${this.label('report')} №${report.id}: ${this.label(`report_${report.state}`)}`
        if (report.url) item.append(createNode('a', null, text).attr('href', report.url))
        else item.append(createNode('span', null, text))
        if (report.potentially_stale) item.append(createNode('span', 'bordereau-panel__warning', ` — ${this.label('report_potentially_stale')}`))
        list.append(item)
      })
      panel.append(list)
    }

    if (assessment.issues.some((issue) => issue.code === 'sent_to_insurance')) {
      panel.append(createNode('div', 'bordereau-panel__warning', this.label('sent_to_insurance')))
    }
  }

  panelRow(label, value) {
    const row = createNode('div', 'bordereau-panel__row')
    row.append(createNode('strong', null, `${label}: `))
    value instanceof $ ? row.append(value) : row.append(createNode('span', null, value))
    return row
  }

  formatSize(bytes) {
    const size = Number(bytes)
    if (size < 1024) return `${size} ${this.label('bytes')}`
    return `${(size / 1024).toFixed(1)} ${this.label('kilobytes')}`
  }

  formatTime(value) {
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ru-RU')
  }

  setButtons(buttons) {
    this.dialog.dialog('option', 'buttons', buttons)
  }

  close() {
    this.dialog.dialog('close')
  }
}

$(document).on('click', BORDEREAU_ACTION_SELECTOR, function(event) {
  event.preventDefault()
  new BordereauModal(this).open()
})
